"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Fri Nov 23 2018
*/

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Class that represents change of document from some DB collection. Changes are stored in separate collection.
 *
 * @author JMt
 * @author MSu
 */


var SessionItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SessionItem, _DomainObject_1$Domai);

  function SessionItem(id, sessionId, documentType, document) {
    var _this;

    _classCallCheck(this, SessionItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SessionItem).call(this));
    _this.id = id;
    _this.sessionId = sessionId;
    _this.documentType = documentType;
    _this.document = document;
    return _this;
  }

  return SessionItem;
}(DomainObject_1.DomainObject);

exports.SessionItem = SessionItem;